import List from "./List";
import Create from "./Create";
import Show from "./Show";
import Edit from "./Edit";

export const KeywordCreate = Create;
export const KeywordList = List;
export const KeywordShow = Show;
export const KeywordEdit = Edit;
